module.exports = __webpack_public_path__ + "static/favicon-8cf5e180c6d4c33cfe5ab92aff9abfff.ico";